(()=>{
  const reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function initIntro(){
    const intro=document.getElementById('mcIntro');
    const html=document.documentElement;
    const body=document.body;
    if(!intro||html.classList.contains('mc-intro-seen')){
      body&&body.classList.remove('mc-intro-lock');
      intro&&intro.remove();
      return;
    }
    const started=performance.now();
    const minimum=reduce?650:3000;
    let scheduled=false;
    requestAnimationFrame(()=>intro.classList.add('is-ready'));
    const leave=()=>{
      if(scheduled)return;
      scheduled=true;
      const wait=Math.max(0,minimum-(performance.now()-started));
      window.setTimeout(()=>{
        intro.classList.add('is-leaving');
        body&&body.classList.remove('mc-intro-lock');
        html.classList.add('mc-intro-seen');
        try{sessionStorage.setItem('mcIntroSeen','1')}catch(error){}
        window.setTimeout(()=>intro.remove(),reduce?240:820);
      },wait);
    };
    if(document.readyState==='complete')leave();
    else window.addEventListener('load',leave,{once:true});
    window.setTimeout(leave,5000);
  }
  initIntro();
  function init(root=document){
    const reveals=[...root.querySelectorAll('.mc-reveal:not([data-mc-reveal-ready])')];
    reveals.forEach(el=>el.dataset.mcRevealReady='true');
    if(!('IntersectionObserver' in window)||reduce){reveals.forEach(el=>el.classList.add('is-visible'));}
    else{
      const io=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.add('is-visible');io.unobserve(entry.target);}}),{threshold:.08});
      reveals.forEach(el=>io.observe(el));
    }
    root.querySelectorAll('[data-mc-card]:not([data-mc-card-ready])').forEach(card=>{
      card.dataset.mcCardReady='true';
      if(reduce||!window.matchMedia('(hover:hover) and (pointer:fine)').matches)return;
      card.addEventListener('mousemove',e=>{const r=card.getBoundingClientRect();const x=(e.clientX-r.left)/r.width;const y=(e.clientY-r.top)/r.height;card.style.setProperty('--mx',`${x*100}%`);card.style.setProperty('--my',`${y*100}%`);card.style.transform=`translateY(-8px) perspective(900px) rotateX(${(y-.5)*-4}deg) rotateY(${(x-.5)*4}deg)`;});
      card.addEventListener('mouseleave',()=>card.style.transform='');
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init(document));else init(document);
  document.addEventListener('shopify:section:load',event=>init(event.target));
})();
